import React from 'react';
import { useTranslation } from 'react-i18next';
import { SuggestComboBox, SuggestComboBoxProps } from '../ComboBox/AbstractComboBox/SuggestComboBox';
import { TopUserResult } from '../ComboBox';
import { useHtmlValidId } from '../../../../../hooks/useHtmlValidId';
import getUserTopResults from '../ComboBox/User/getUserTopResults';
import ListItemPerson from '../ComboBox/AbstractComboBox/ListItemPerson/ListItemPerson';
import { FormsComboboxMultiSelectList } from '../FormsComboboxMultiSelect/partials/FormsComboboxMultiSelectList';
import { SelectParam, Select, Option } from '../../../../../_lib/Form2';
import { UserWithRolesSelectListItem } from './UserWithRolesSelectListItem';
import { useUserSelection } from './useUserSelection';

type RoleParamSingle = SelectParam<'roleId'>;

export type UserWithRolesSelectSingleRoleProps = {
  idPrefix: string;
  roleParam: RoleParamSingle;
  suggestComboBoxProps: Omit<SuggestComboBoxProps<TopUserResult>, 'id' | 'onSelection' | 'validationMessage'>;
};

export function UserWithRolesSelectSingleRole({
  idPrefix,
  roleParam,
  suggestComboBoxProps,
}: UserWithRolesSelectSingleRoleProps) {
  const { t } = useTranslation('Members');
  const { selectedResults, addResult, removeResult } = useUserSelection();

  const id = useHtmlValidId();
  const headerLabelId = useHtmlValidId();

  return (
    <>
      <SuggestComboBox
        {...suggestComboBoxProps}
        name={undefined}
        id={`${idPrefix}select-combobox-${id}`}
        responseMapper={getUserTopResults}
        onSelection={(item: TopUserResult | undefined) => {
          addResult(item);
        }}
        validationMessage={
          suggestComboBoxProps.required && !selectedResults.length
            ? t('FormsComboBox:content.validationMessage')
            : undefined
        }
      >
        {item => <ListItemPerson user={item} />}
      </SuggestComboBox>
      {selectedResults && selectedResults.length > 0 && (
        <>
          <h3 className="invisible" id={headerLabelId}>
            {t('selectedPersons')}
          </h3>
          <FormsComboboxMultiSelectList labelId={headerLabelId} modifier="margin-top">
            {selectedResults.map((selectedResult, userId) => (
              <UserWithRolesSelectListItem
                key={selectedResult.id}
                selectedResult={selectedResult}
                removeResult={removeResult}
                userId={userId}
              >
                <Select
                  label={t('glossary:role')}
                  labelHidden={true}
                  param={{
                    ...roleParam,
                    name: `memberships[${userId}].roleId`,
                  }}
                >
                  {roleParam.options?.map((option: { value: string; text: string }) => (
                    <Option key={option.value} value={option.value}>
                      {option.text}
                    </Option>
                  ))}
                </Select>
              </UserWithRolesSelectListItem>
            ))}
          </FormsComboboxMultiSelectList>
        </>
      )}
    </>
  );
}
